'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import type { FC } from 'react';
import useBreakpoints from '@/hooks/useBreakpoints';
import { Button } from '@/shared/components/Button';
import { Modal } from '@/utils/antd-imports';
interface InstallAppModalProps {
  isOpen: boolean;
  onClose: () => void;
  isMobile?: boolean;
  hasApp?: boolean;
}

/**
 * @description Modal component for platform_install_app action
 */
export const InstallAppModal: FC<InstallAppModalProps> = t0 => {
  const $ = _c(29);
  const {
    isOpen,
    onClose,
    isMobile: t1,
    hasApp: t2
  } = t0;
  const isMobile = t1 === undefined ? false : t1;
  t2 === undefined ? true : t2;
  const {
    lg,
    tablet
  } = useBreakpoints();
  const t = useTranslations("actions.install_app");
  let t3;
  if ($[0] !== isMobile || $[1] !== t) {
    const getModalContent = () => {
      if (isMobile) {
        return {
          title: t("title_mobile"),
          subtitle: t("subtitle_mobile"),
          showSubtitle: true
        };
      } else {
        return {
          title: t("title_desktop"),
          subtitle: t("subtitle_desktop"),
          showSubtitle: true
        };
      }
    };
    t3 = getModalContent();
    $[0] = isMobile;
    $[1] = t;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const content = t3;
  const t4 = lg ? "32px " : tablet ? "24px" : "20px";
  let t5;
  if ($[3] !== t4) {
    t5 = {
      body: {
        display: "flex",
        flexDirection: "column",
        height: "auto",
        padding: t4,
        minHeight: "auto",
        background: "#1E1E2A",
        backdropFilter: "blur(36.85px)",
        borderRadius: "24px",
        maxWidth: "560px"
      }
    };
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = `absolute ${lg ? "right-[16px] top-[16px]" : "right-[12px] top-[12px]"}  flex items-center justify-center rounded-full border border-[#E9ECF033] p-2 transition-colors hover:bg-white/10`;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Image src="/icons/close-default.svg" width={12} height={12} alt="Close" />;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== onClose || $[7] !== t6) {
    t8 = <button onClick={onClose} className={t6}>{t7}</button>;
    $[6] = onClose;
    $[7] = t6;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== content.title) {
    t9 = <h2 className="w-full text-pretty text-center  text-[24px] font-bold leading-[1.2] text-white  lg:text-[36px] "><pre className="font-primary">{content.title}</pre></h2>;
    $[9] = content.title;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== content.showSubtitle || $[12] !== content.subtitle) {
    t10 = content.showSubtitle && <p className="text-md w-full text-pretty text-center font-medium leading-[1.2] text-[#E9ECF0CC] tablet:text-[20px] ">{content.subtitle}</p>;
    $[11] = content.showSubtitle;
    $[12] = content.subtitle;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t9) {
    t11 = <div className="mb-6 flex items-start gap-4"><div className="flex w-full flex-1 flex-col gap-4 tablet:gap-6">{t9}{t10}</div></div>;
    $[14] = t10;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t) {
    t12 = t("button");
    $[17] = t;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== onClose || $[20] !== t12) {
    t13 = <div className="mt-2 flex flex-col justify-end tablet:mt-5"><Button variant="whiteSecondary" size="md_a" onClick={onClose}>{t12}</Button></div>;
    $[19] = onClose;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== isOpen || $[23] !== onClose || $[24] !== t11 || $[25] !== t13 || $[26] !== t5 || $[27] !== t8) {
    t14 = <Modal open={isOpen} onCancel={onClose} footer={null} centered={true} className="[&_.ant-modal-content]:!bg-transparent" styles={t5} closable={false}>{t8}{t11}{t13}</Modal>;
    $[22] = isOpen;
    $[23] = onClose;
    $[24] = t11;
    $[25] = t13;
    $[26] = t5;
    $[27] = t8;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  return t14;
};
export default InstallAppModal;